<template>
    <div class="container mx-auto px-4 py-6 lista-usuarios-page">
      <div v-if="documentosDescargables.length" class="documentos-descargables-panel" :aria-label="t('documents.title')">
        <a
          v-if="documentosDescargables.length === 1"
          class="documento-descarga-btn"
          :href="documentosDescargables[0].download_url"
          target="_blank"
          rel="noopener"
          download
        >
          {{ documentosDescargables[0].etiqueta_boton || documentosDescargables[0].nombre_original }}
        </a>
        <button
          v-else
          type="button"
          class="documento-descarga-btn"
          @click="showDocumentosModal = true"
        >
          {{ t('documents.downloadable') }}
        </button>
      </div>

      <div
        v-if="showDocumentosModal"
        class="documentos-modal-bg"
        role="dialog"
        aria-modal="true"
        :aria-label="t('documents.title')"
        @click.self="showDocumentosModal = false"
      >
        <div class="documentos-modal-box">
          <div class="documentos-modal-header">
            <h3>{{ t('documents.title') }}</h3>
            <button type="button" class="documentos-modal-close" :aria-label="t('common.close')" @click="showDocumentosModal = false">
              x
            </button>
          </div>

          <div class="documentos-modal-list">
            <a
              v-for="doc in documentosDescargables"
              :key="doc.id_evento_documento"
              class="documento-descarga-btn documento-descarga-btn-modal"
              :href="doc.download_url"
              target="_blank"
              rel="noopener"
              download
              @click="showDocumentosModal = false"
            >
              {{ doc.etiqueta_boton || doc.nombre_original }}
            </a>
          </div>
        </div>
      </div>
      <!-- Botón para abrir el modal -->
        <div v-if="$canView('superadministrador', 'administradorevento')" class="boton-svg">
          <button @click="showModalButtons = true" class="modal-trigger-button">            
              <IconoEngraneConfiguraciones></IconoEngraneConfiguraciones>
          </button>
        </div>
        <div class="boton-tutorial">
          <a target="_blank" href="http://qr.link/8Z6dgw">{{ t('page.tutorial') }}</a>
        </div>
        <!-- Modal que contiene los botones -->
        <div v-if="showModalButtons" class="modal">
        <div class="modal-content">
            <div v-if="$canView('superadministrador')" class="botones">
                <AgregarSuperAdministrador @userCreated="fetchGroups" :eventoToken="eventoToken" />
              </div>
              <div v-if="$canView('superadministrador', 'administradorevento')" class="botones">
                <a target="_blank" class="boton-front bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-1 rounded w-full" :href="`/check-status-event/${eventoToken}`">{{ t('page.eventSummary') }}</a>
                <CreateGroupModal v-if="!fechaCorte" @groupCreated="fetchGroups" :eventoToken="eventoToken" :sin-limites-carga-usuarios="sinLimitesCargaUsuarios" :label-staff="displayLabelStaff" :label-asistentes="displayLabelAsistentes" :label-expositor="displayLabelExpositor" />
                <button
                  v-if="$canView('superadministrador')"
                  @click="descargarTodosLosUsuarios"
                  :disabled="exportandoTodos || !dataReadyForDownloads"
                  class="boton-front bg-emerald-600 hover:bg-emerald-700 disabled:opacity-60 text-white font-bold py-1 px-1 rounded w-full"
                >
                  {{ exportandoTodos ? t('page.downloading') : (!dataReadyForDownloads ? t('page.loadingData') : t('page.downloadAll')) }}
                </button>
                <CargaGrupos v-if="!fechaCorte" @groupCreated="fetchGroups" :eventoToken="eventoToken" />
                <a target="_blank" class="boton-front bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-1 rounded w-full" :href="`/approve-users/${eventoToken}`">{{ t('page.userApproval') }}</a>
                <AdministradoresEventoModal
                  v-if="!fechaCorte"
                  :eventoToken="eventoToken"
                  :fechaCorte="fechaCorte"
                  @userCreated="fetchGroups"
                />
                <EnviarMasivoEvento
                  v-if="!fechaCorte"
                    :eventoToken="eventoToken"
                    @massSent="fetchGroups"
                />

                <EnvioMagicLinksEvento v-if="!fechaCorte"  :eventoToken="eventoToken" />
            </div>
            <button @click="showModalButtons = false" class="mt-2 bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded">{{ t('common.close') }}</button>
        </div>
        </div>
        <div v-if="$canView('superadministrador', 'administradorevento') && mostrarBotonRegistroStand" class="mb-5">
          <BotonFormularioUsuarioEmpresa :eventoToken="eventoToken" />
        </div>

      <div class="user-management-toolbar" :class="{ 'has-downloadable-documents': documentosDescargables.length }">
        <h2 class="text-xl font-semibold text-gray-800">{{ t('page.title') }}</h2>
        <div class="language-switcher" role="group" :aria-label="t('language.label')">
          <span class="language-switcher-label">{{ t('language.label') }}</span>
          <button
            type="button"
            class="language-option"
            :class="{ active: uiLanguage === 'es' }"
            :aria-pressed="uiLanguage === 'es'"
            @click="setUiLanguage('es')"
          >
            ES <span>{{ t('language.spanish') }}</span>
          </button>
          <button
            type="button"
            class="language-option"
            :class="{ active: uiLanguage === 'en' }"
            :aria-pressed="uiLanguage === 'en'"
            @click="setUiLanguage('en')"
          >
            EN <span>{{ t('language.english') }}</span>
          </button>
        </div>
      </div>

      <DownloadButton v-if="!fechaCorte" 
        :labelStaff="displayLabelStaff"
        :labelAsistentes="displayLabelAsistentes"
        :labelExpositor="displayLabelExpositor"
        :language="uiLanguage"
        :camposObligatorios="camposObligatorios"
        :disabled="!dataReadyForDownloads"
      />

      <div v-if="$canView('superadministrador', 'administradorevento')" class="group-search-panel">
        <label class="group-search-label" for="group-search-input">{{ t('page.searchGroup') }}</label>
        <div class="group-search-box">
          <input
            id="group-search-input"
            v-model="groupSearch"
            type="search"
            class="group-search-input"
            :placeholder="t('page.searchPlaceholder')"
            autocomplete="off"
            @input="handleGroupSearchInput"
          />
          <button
            v-if="groupSearch"
            type="button"
            class="group-search-clear"
            @click="clearGroupSearch"
          >
            {{ t('common.clear') }}
          </button>
        </div>
      </div>

      <div v-if="loading">
        {{ t('page.loadingUsers') }}
      </div>
      <div v-else style="width: 100%">
        <div v-for="group in groups" :key="group.group_id" class="mb-4 p-4 bg-white shadow-md rounded-lg">
          <div class="flex justify-between items-center mb-3">
            <h3 class="text-lg titulo-grupo font-bold">
              <EditGroupModal
                v-if="$canView('superadministrador','administradorevento') && !fechaCorte && group.grupo_activo == 1"
                :group="group"
                v-model:staff="group.staff"
                v-model:asistentes="group.asistentes"
                v-model:conferencistas="group.conferencistas"
                :labelStaff="displayLabelStaff"
                :labelAsistentes="displayLabelAsistentes"
                :labelExpositor="displayLabelExpositor"
                :sin-limites-carga-usuarios="sinLimitesCargaUsuarios"
                @groupUpdated="handleGroupUpdated"
                @groupDeleted="handleGroupDeleted"
              />
              <EnvioMagicLinksGrupo  v-if="$canView('superadministrador','administradorevento','administrador') && !fechaCorte && group.grupo_activo == 1" :grupoToken="group.group_id"/>
              <CerrrarGrupo  v-if="$canView('superadministrador','administradorevento') && !fechaCorte && group.grupo_activo == 1 && !groupsModified[group.group_id]" :grupoToken="group.group_id" />
              <div v-if="$canView('superadministrador','administradorevento') && group.grupo_activo == 0 && !groupsModified[group.group_id]" :grupo-token="group.group_id">
                <button
                  @click="descargarCSV(group)"
                  :disabled="!dataReadyForDownloads"
                  class="bg-blue-500 hover:bg-blue-700 disabled:opacity-60 text-white font-bold py-1 px-3 rounded"
                >
                     CSV 
                </button>
                <button
                  @click="descargarXLSX(group)"
                  :disabled="!dataReadyForDownloads"
                  class="ml-2 bg-green-500 hover:bg-green-700 disabled:opacity-60 text-white font-bold py-1 px-3 rounded"
                >
                     XLSX 
                </button>
            </div>

              <!-- <CerrrarGrupo  v-if="$canView('superadministrador','administradorevento','administrador') && !fechaCorte && group.grupo_activo == 1" :grupoToken="group.group_id"/> -->
              {{ group.group_name }}
            </h3>
            <!-- dentro del v-for="group in groups" ... -->
            <EditarDetalleEmpresa
              v-if="$canView('superadministrador','administradorevento') && !fechaCorte && group.grupo_activo == 1"
              :group-id="group.group_id"         
              :group-token="group.token"         
            />

            <RegistroUsuarioGrupo :groupId="group.group_id" @user-registered="handleGroupUpdated" />
            <div>
              <button v-if="$canView('superadministrador','administradorevento','administrador') && !fechaCorte && group.grupo_activo == 1" @click="addUser(group.group_id)" class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-3 rounded">{{ t('page.addModerator') }}</button>
            </div>
          </div>          
            <TablaAdministradores :grupo-token="group.group_id" :fechaCorte="fechaCorte" :grupo_activo="group.grupo_activo" :group="group" @user-deleted="handleUserDeleted"></TablaAdministradores>                      
            
          <!-- dentro del v-for de group -->
            <template v-for="c in categories" :key="`${group.group_id}-${c.key}`">
              <TablaInvitados
                v-if="categoryVisible(group, c.key)"
                :group="group"
                :group-id="group.group_id"
                :grupo_activo="group.grupo_activo"
                :eventoToken="eventoToken"
                :groupName="group.group_name"

                :category="c.key"
                :title="c.title"

                :count="categoryDisplayCount(group, c.key)"
                :fechaCorte="fechaCorte"
                :members="group.staff_members[c.key]"
                :visible="categoryVisible(group, c.key)"
                :sin-limite="sinLimitesCargaUsuarios"
                :loading="excelLoading.group_id === group.group_id && excelLoading.category === c.key"
                :is-open="isAccordionOpen(group.group_id, c.key)"
                :campos-obligatorios="camposObligatorios"
                :groupsModified="groupsModified"

                @solicitud-modificacion="markGroupAsModified"
                @trigger-file-input="triggerFileInput"
                @file-changed="handleFileChange"
                @toggle-accordion="toggleAccordion"

       
                @perform-save="performSaveByCategory(group, c.key)"

                @approve-user="approveUser"
                @show-modal="showModal"
                @group-modified="markGroupAsModified"
                @update-members="updateMembers"
                @reset-category="confirmResetCategoryUsers"
              />
            </template>
                 

             <!-- <button v-if="!fechaCorte && group.grupo_activo == 1" class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-3 rounded" @click="performSaveAllMembers(group)">Guardar Todos</button>
      -->
            </div>
      </div>
      <div class="flex justify-between items-center mt-4" v-if="pager.totalPages > 1">
        <button :disabled="pager.currentPage === 1" 
                @click="fetchGroups(pager.currentPage - 1)"
                class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded disabled:opacity-50">
            {{ t('page.previous') }}
        </button>
        <span>{{ t('page.pageOf', { current: pager.currentPage, total: pager.totalPages }) }}</span>
        <button :disabled="pager.currentPage === pager.totalPages"
                @click="fetchGroups(pager.currentPage + 1)"
                class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded disabled:opacity-50">
            {{ t('page.next') }}
        </button>
        </div>
         <!-- Modal de confirmación -->
        <div v-if="showConfirmationModal" class="fixed z-10 inset-0 overflow-y-auto">
            <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div class="fixed inset-0 transition-opacity" aria-hidden="true">
                <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
            </div>

            <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true"></span>

            <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
                <div class="sm:flex sm:items-start">
                <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100 sm:mx-0 sm:h-10 sm:w-10">
                    <IconoAtencionModal></IconoAtencionModal>
                </div>
                <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                    <h3 class="text-lg leading-6 font-medium text-gray-900 mt-2">
                        {{ t('excel.bulkUploadTitle', { category: selectedCategoryLabel() }) }}
                    </h3>
                    <div class="mt-3 space-y-2">
                      <p class="text-sm text-gray-600">
                        {{ t('excel.chooseProcessing') }}
                      </p>
                      <p v-if="!sinLimitesCargaUsuarios" class="text-sm text-gray-500">
                        <b>{{ t('excel.overwriteShort') }}</b> {{ t('excel.overwriteHelp') }}
                      </p>
                      <p class="text-sm text-gray-500">
                        <b>{{ t('excel.mergeShort') }}</b> {{ t('excel.mergeHelp') }}
                      </p>
                      <p v-if="sinLimitesCargaUsuarios" class="text-sm text-gray-500">
                        {{ t('excel.unlimitedHelp') }}
                      </p>
                    </div>
                </div>
                </div>
                <div class="mt-5 sm:mt-4 flex flex-col gap-3">
                  <button @click="confirmUpload('merge')" type="button" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-emerald-600 text-base font-medium text-white hover:bg-emerald-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500 sm:text-sm">
                      {{ t('excel.mergeAction') }}
                  </button>
                  <button v-if="!sinLimitesCargaUsuarios" @click="confirmUpload('overwrite')" type="button" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:text-sm">
                      {{ t('excel.overwriteAction') }}
                  </button>
                  <button @click="cancelUpload" type="button" class="w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm">
                      {{ t('common.cancel').toUpperCase() }}
                  </button>
                </div>
            </div>
            </div>
             <!-- Modal de Confirmación -->
            </div>
        <ModalConfirm
            :is-visible="isModalVisible"
            :title="t('members.deleteConfirmation')"
            :message="t('members.deleteQuestion')"
            @confirm="clearMember"
            @cancel="closeModal"
        ></ModalConfirm>

        <!-- Modal de progreso -->
      <template v-if="showProgressModal">
        <div class="overlay"></div>
        <div class="modal-progress">
          <h2>{{ progressMessage }}</h2>
          <div style="margin-top:10px">{{ t('page.wait') }}</div>
        </div>
      </template>

      <!-- Modal de errores -->
      <template v-if="showErrorModal">
        <div class="overlay"></div>
        <div class="modal-errores">
          <h2>{{ t('page.errorsFound') }}</h2>
          <ul>
            <li v-for="(e, idx) in errorList" :key="idx">
              <strong>{{ t('page.record', { row: e.row || '—' }) }}</strong>: {{ e.message }}
            </li>
          </ul>
          <button @click="showErrorModal = false">{{ t('common.close') }}</button>
        </div>
      </template>

    </div>
  </template>

<script>
import * as XLSX from "xlsx";
import axios from "axios";
import EditGroupModal from "@/views/usuarios/modals/EditGroupModal.vue";
import CreateGroupModal from "@/components/modals/groupModal/CreateGroupModal.vue";
import CargaGrupos from "@/components/CargaGrupos/CargaGrupos.vue";
import { useToast } from "vue-toastification";
import DownloadButton from "@/components/DownloadButton.vue";
import AgregarSuperAdministrador from "@/components/administracion/AgregarSuperAdministrador.vue";
import BotonFormularioUsuarioEmpresa from "./BotonFormularioUsuarioEmpresa.vue";
import RegistroUsuarioGrupo from "./RegistroUsuarioGrupo.vue";
import EditarDetalleEmpresa from "./EditarDetalleEmpresa.vue";
import ModalConfirm from "@/components/modals/ModalConfirm.vue";
import IconoEngraneConfiguraciones from "./svgs/IconoEngraneConfiguraciones.vue";
import IconoAtencionModal from "./svgs/IconoAtencionModal.vue";
import TablaAdministradores from "./tablas/TablaAdministradores.vue";
import TablaInvitados from "./tablas/TablaInvitados.vue";
import EnvioMagicLinksEvento from "@/components/administracion/EnvioMagicLinksEvento.vue";
import EnvioMagicLinksGrupo from "@/components/administracion/EnvioMagicLinksGrupo.vue";
import EnviarMasivoEvento from "@/components/administracion/EnviarMasivoEvento.vue";
import CerrrarGrupo from "@/components/administracion/CerrrarGrupo.vue";
import AdministradoresEventoModal from "@/components/administracion/modal/AdministradoresEventoModal.vue";

import { PAISES, normKey } from "@/utils/paises";
import { fillExistingData } from "./metodos/InicializarValidarMiembros.js";
import {
  saveAllMembers,
  saveStaffMembers,
  saveConferencistas,
  saveAsistentes,
  setProgressModal,
  setErrorModal,
  getLastValidationErrors,
} from "./services/saveMembersService.js";
import { computed, reactive } from "vue";
import {
  getUserManagementLanguage,
  setUserManagementLanguage,
  translateUserManagement,
} from "./i18n/userManagementI18n.js";
import {
  getEventFieldHeaderAliases,
  getEventFieldLabel,
} from "./i18n/eventFieldLabels.js";

const NON_MEMBER_DATA_FIELDS = new Set([
  "staff_id",
  "group_id",
  "evento_id",
  "escarapela",
  "autorizado",
  "estado",
  "creado",
  "editado",
  "borrado",
  "isModified",
  "isSaved",
]);

export default {
  name: "ListaGruposUsuarios",

  props: {
    eventoToken: { type: String, required: true },
    grupoToken: { type: String, default: null },
  },

  setup() {
    const toast = useToast();
    return { toast };
  },

  data() {
    return {
      groups: [],
      loading: true,
      role: null,

      excelLoading: { group_id: null, category: "" },

      expandedGroup: null,
      expandedCategory: null,

      pager: { currentPage: 1, totalPages: 0 },

      showConfirmationModal: false,
      selectedGroupId: null,
      selectedCategory: "",
      selectedFile: null,

      isModalVisible: false,
      currentGroup: null,
      currentCategory: null,
      currentIndex: null,

      showModalButtons: false,

      infoEvento: [],
      validarMandatorio: false,
      camposObligatorios: [],
      roleLoaded: false,
      fechaResponse: null,
      fechaCorte: false,
      groupsModified: reactive({}),

      progressMessage: "",
      showProgressModal: false,
      errorList: [],
      showErrorModal: false,
      exportandoTodos: false,

      labelStaff: "Staff",
      labelAsistentes: "Asistentes",
      labelExpositor: "Expositores",
      labelStaffEn: "",
      labelAsistentesEn: "",
      labelExpositorEn: "",
      tieneRecintosReservas: false,
      documentosDescargables: [],
      showDocumentosModal: false,
      groupSearch: "",
      groupSearchTimer: null,
      groupDraftsById: {},
      uiLanguage: getUserManagementLanguage(),
    };
  },

  components: {
    CreateGroupModal,
    EditGroupModal,
    CargaGrupos,
    DownloadButton,
    AgregarSuperAdministrador,
    ModalConfirm,
    EnvioMagicLinksEvento,
    EnvioMagicLinksGrupo,
    EnviarMasivoEvento,
    IconoEngraneConfiguraciones,
    CerrrarGrupo,
    IconoAtencionModal,
    TablaAdministradores,
    TablaInvitados,
    BotonFormularioUsuarioEmpresa,
    RegistroUsuarioGrupo,
    EditarDetalleEmpresa,
    AdministradoresEventoModal,
  },

  provide() {
    return {
      canApproveComputed: this.canApproveComputed,
      userManagementI18n: {
        language: computed(() => this.uiLanguage),
        t: (key, params = {}) => translateUserManagement(this.uiLanguage, key, params),
      },
    };
  },

  computed: {
    canApproveComputed() {
      return (user) => user && !user.isModified && user.isSaved;
    },
    sinLimitesCargaUsuarios() {
      return this.infoEvento && (this.infoEvento.sin_limites_carga_usuarios === true || this.infoEvento.sin_limites_carga_usuarios === 1 || this.infoEvento.sin_limites_carga_usuarios === '1');
    },
    categories() {
      return [
        { key: "staff", title: this.displayLabelStaff },
        { key: "conferencistas", title: this.displayLabelExpositor },
        { key: "asistentes", title: this.displayLabelAsistentes },
      ];
    },
    displayLabelStaff() {
      return this.eventCategoryLabel(this.labelStaff, this.labelStaffEn, "staff");
    },
    displayLabelAsistentes() {
      return this.eventCategoryLabel(this.labelAsistentes, this.labelAsistentesEn, "asistentes");
    },
    displayLabelExpositor() {
      return this.eventCategoryLabel(this.labelExpositor, this.labelExpositorEn, "conferencistas");
    },
    mostrarBotonRegistroStand() {
      return this.tieneRecintosReservas;
    },
    dataReadyForDownloads() {
      const hasEventConfig = this.infoEvento && !Array.isArray(this.infoEvento) && Object.keys(this.infoEvento).length > 0;
      const hasFields = Array.isArray(this.camposObligatorios) && this.camposObligatorios.length > 0;
      return !this.loading && hasEventConfig && hasFields && Array.isArray(this.groups);
    },
  },

  watch: {
    "pager.currentPage"(newPage) {
      this.fetchGroups(newPage);
    },
  },

  methods: {
    t(key, params = {}) {
      return translateUserManagement(this.uiLanguage, key, params);
    },

    setUiLanguage(language) {
      this.uiLanguage = setUserManagementLanguage(language);
    },

    localizedCategoryLabel(value, category) {
      const label = String(value || "").trim();
      const normalized = label.toLowerCase();
      const defaults = {
        staff: { key: "categories.staff", aliases: ["", "staff"] },
        conferencistas: { key: "categories.speakers", aliases: ["", "expositores", "expositor", "conferencistas", "conferencista"] },
        asistentes: { key: "categories.attendees", aliases: ["", "asistentes", "asistente"] },
      };
      const config = defaults[category];

      if (config && config.aliases.includes(normalized)) {
        return this.t(config.key);
      }
      return label || category;
    },

    eventCategoryLabel(spanishValue, englishValue, category) {
      const englishLabel = String(englishValue || "").trim();
      if (this.uiLanguage === "en" && englishLabel) {
        return englishLabel;
      }

      return this.localizedCategoryLabel(spanishValue, category);
    },

    normalizeEventLabel(value, fallback) {
      const label = String(value || "").trim();
      return label || fallback;
    },

    applyEventLabels(evento = {}) {
      this.labelStaff = this.normalizeEventLabel(evento?.auto_staff, "Staff");
      this.labelAsistentes = this.normalizeEventLabel(evento?.auto_asistente, "Asistentes");
      this.labelExpositor = this.normalizeEventLabel(evento?.auto_expositor, "Expositores");
      this.labelStaffEn = String(evento?.auto_staff_en || "").trim();
      this.labelAsistentesEn = String(evento?.auto_asistente_en || "").trim();
      this.labelExpositorEn = String(evento?.auto_expositor_en || "").trim();
    },

    // ----------------------------
    // SAVE helpers
    // ----------------------------
    async performSaveByCategory(group, category) {
      if (category === "staff") return this.performSaveStaffMembers(group);
      if (category === "conferencistas") return this.performSaveConferencistas(group);
      if (category === "asistentes") return this.performSaveAsistentes(group);
    },

    handleShowProgressModal(message) {
      if (message) {
        this.progressMessage = message;
        this.showProgressModal = true;
      } else {
        this.showProgressModal = false;
      }
    },

    handleShowErrorModal(errores) {
      this.errorList = errores;
      this.showErrorModal = true;
    },

    // ----------------------------
    // Export grupo (CSV / XLSX) y exportación global del evento
    // ----------------------------
    camposExportacionOrdenados() {
      const fallbackFields = [
        { label: "nombres", nombre_del_campo: "Nombres", tipo_ui: "input" },
        { label: "apellidos", nombre_del_campo: "Apellidos", tipo_ui: "input" },
        { label: "numero_de_documento", nombre_del_campo: "Número de Documento", tipo_ui: "input" },
        { label: "correo_electronico", nombre_del_campo: "Correo Electrónico", tipo_ui: "input" },
        { label: "tipo_de_documento", nombre_del_campo: "Tipo de Documento", tipo_ui: "input" },
        { label: "telefono", nombre_del_campo: "Teléfono", tipo_ui: "input" },
        { label: "ciudad", nombre_del_campo: "Ciudad", tipo_ui: "input" },
        { label: "pais", nombre_del_campo: "País", tipo_ui: "input" },
        { label: "departamento", nombre_del_campo: "Departamento", tipo_ui: "input" },
        { label: "categoria", nombre_del_campo: "Categoría", tipo_ui: "input" },
        { label: "empresa", nombre_del_campo: "Empresa", tipo_ui: "input" },
        { label: "profesion", nombre_del_campo: "Profesión", tipo_ui: "input" },
        { label: "especialidad", nombre_del_campo: "Especialidad", tipo_ui: "input" },
        { label: "direccion", nombre_del_campo: "Dirección", tipo_ui: "input" },
        { label: "indicativo_de_telefono", nombre_del_campo: "Indicativo de teléfono", tipo_ui: "input" },
      ];

      const activos = Array.isArray(this.camposObligatorios)
        ? this.camposObligatorios.filter((campo) => campo && campo.activo && campo.label)
        : [];

      const source = activos.length ? activos.slice() : fallbackFields;

      return source.sort((a, b) => {
        const ordenA = Number(a?.orden);
        const ordenB = Number(b?.orden);
        const hasOrdenA = Number.isFinite(ordenA) && ordenA > 0;
        const hasOrdenB = Number.isFinite(ordenB) && ordenB > 0;

        if (hasOrdenA && hasOrdenB && ordenA !== ordenB) return ordenA - ordenB;
        if (hasOrdenA !== hasOrdenB) return hasOrdenA ? -1 : 1;
        return 0;
      });
    },

    getExportCategoryTitle(categoryKey) {
      const exportLabels = {
        staff: this.displayLabelStaff,
        conferencistas: this.displayLabelExpositor,
        asistentes: this.displayLabelAsistentes,
      };
      return exportLabels[categoryKey] || this._humanizeLabel(categoryKey);
    },

    getExportHeaders(includeContext = false) {
      const headers = [];

      if (includeContext) {
        headers.push(this.t("excel.group"), this.t("excel.userType"));
      }

      this.camposExportacionOrdenados().forEach((field) => {
        headers.push(getEventFieldLabel(field, this.uiLanguage));
      });

      return headers;
    },

    normalizeExportValue(member, field) {
      const value = member?.[field.label];

      if (value === null || value === undefined) return "";
      if (Array.isArray(value)) {
        return value.map((item) => String(item ?? "").trim()).filter(Boolean).join(", ");
      }
      if (typeof value === "object") {
        try {
          return JSON.stringify(value);
        } catch (error) {
          return String(value);
        }
      }

      const normalized = String(value);
      if (String(field?.tipo_ui || "").toLowerCase() === "multicheck") {
        return normalized
          .split(",")
          .map((item) => item.trim())
          .filter(Boolean)
          .join(", ");
      }

      return normalized;
    },

    getExportCategoryKeys() {
      return ["staff", "conferencistas", "asistentes"];
    },

    getCategoryCapacity(group, categoryKey) {
      return Number(group?.[categoryKey] || 0);
    },

    shouldExportEmptyCategoryRow(group, categoryKey, members) {
      if (this.sinLimitesCargaUsuarios) {
        if (categoryKey === "staff") return String(group?.mostrar_staff || "0") === "1" || members.length > 0;
        if (categoryKey === "conferencistas") return String(group?.mostrar_conferencistas || "0") === "1" || members.length > 0;
        if (categoryKey === "asistentes") return String(group?.mostrar_asistentes || "0") === "1" || members.length > 0;
        return members.length > 0;
      }

      return this.getCategoryCapacity(group, categoryKey) > 0 || members.length > 0;
    },

    isMeaningfulExportMember(member, exportFields) {
      if (!member || typeof member !== "object") return false;

      return (exportFields || []).some((field) => {
        const value = member?.[field.label];
        if (value === null || value === undefined) return false;
        if (Array.isArray(value)) return value.some((item) => String(item ?? "").trim() !== "");
        if (typeof value === "object") return Object.values(value).some((item) => String(item ?? "").trim() !== "");
        return String(value).trim() !== "";
      });
    },

    createExportRow(group, categoryKey, member, exportFields, includeContext = false) {
      const row = [];

      if (includeContext) {
        row.push(group?.group_name || "");
        row.push(this.getExportCategoryTitle(categoryKey));
      }

      exportFields.forEach((field) => {
        row.push(this.normalizeExportValue(member, field));
      });

      return row;
    },

    buildExportRows(groups = [], includeContext = false) {
      const rows = [];
      const exportFields = this.camposExportacionOrdenados();
      const categoryKeys = this.getExportCategoryKeys();

      (groups || []).forEach((group) => {
        categoryKeys.forEach((categoryKey) => {
          const members = Array.isArray(group?.staff_members?.[categoryKey])
            ? group.staff_members[categoryKey]
            : [];

          const realMembers = members.filter((member) => this.isMeaningfulExportMember(member, exportFields));

          if (realMembers.length) {
            realMembers.forEach((member) => {
              rows.push(this.createExportRow(group, categoryKey, member, exportFields, includeContext));
            });
            return;
          }

          if (this.shouldExportEmptyCategoryRow(group, categoryKey, members)) {
            rows.push(this.createExportRow(group, categoryKey, {}, exportFields, includeContext));
          }
        });
      });

      return rows;
    },

    escapeCsvValue(value) {
      const safe = String(value ?? "");
      if (/[",\r\n]/.test(safe)) {
        return `"${safe.replace(/"/g, '""')}"`;
      }
      return safe;
    },

    downloadCsv(headers, rows, filename) {
      const csvLines = [headers, ...rows].map((row) =>
        row.map((cell) => this.escapeCsvValue(cell)).join(",")
      );
      const csvContent = `\uFEFF${csvLines.join("\r\n")}`;
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);
    },

    downloadXlsx(headers, rows, filename, sheetName = null) {
      const ws = XLSX.utils.aoa_to_sheet([headers, ...rows]);
      ws["!cols"] = headers.map((header) => ({ wch: Math.max(16, String(header).length + 4) }));

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, sheetName || this.t("excel.usersSheet"));
      XLSX.writeFile(wb, filename);
    },

    descargarCSV(group) {
      if (!this.dataReadyForDownloads) {
        this.toast.info(this.t("excel.waitForEvent"));
        return;
      }
      const headers = this.getExportHeaders(true);
      const rows = this.buildExportRows([group], true);
      const prefix = this.uiLanguage === "en" ? "group" : "grupo";
      this.downloadCsv(headers, rows, `${prefix}-${group.group_id}.csv`);
    },

    descargarXLSX(group) {
      if (!this.dataReadyForDownloads) {
        this.toast.info(this.t("excel.waitForEvent"));
        return;
      }
      const headers = this.getExportHeaders(true);
      const rows = this.buildExportRows([group], true);
      const prefix = this.uiLanguage === "en" ? "group" : "grupo";
      this.downloadXlsx(headers, rows, `${prefix}-${group.group_id}.xlsx`);
    },

    async descargarTodosLosUsuarios() {
      if (this.exportandoTodos) return;
      if (!this.dataReadyForDownloads) {
        this.toast.info(this.t("excel.waitForEvent"));
        return;
      }

      const incluirWordpress = this.$canView('superadministrador')
        ? window.confirm(this.t("excel.includeWordpress"))
        : false;

      this.exportandoTodos = true;

      try {
        const token = this.$store.state.user.token;
        const response = await axios.post(`/api/usuarios/exportar-evento/${this.eventoToken}`, {
          Authorization: `${token}`,
          include_wordpress: incluirWordpress,
        });

        if (response?.data?.evento) {
          this.applyEventLabels(response.data.evento);
        }

        const groups = Array.isArray(response?.data?.groups) ? response.data.groups : [];
        if (!groups.length) {
          this.toast.info(this.t("excel.noGroups"));
          return;
        }

        const headers = this.getExportHeaders(true);
        const rows = this.buildExportRows(groups, true);

        if (!rows.length) {
          this.toast.info(this.t("excel.noRows"));
          return;
        }

        const timestamp = new Date().toISOString().slice(0, 19).replace(/[T:]/g, "-");
        const filename = this.uiLanguage === "en"
          ? `event-${this.eventoToken}-all-users-${timestamp}.csv`
          : `evento-${this.eventoToken}-todos-los-usuarios-${timestamp}.csv`;
        this.downloadCsv(headers, rows, filename);
        this.toast.success(this.t("excel.eventDownloaded"));
      } catch (error) {
        console.error("Error al descargar todos los usuarios:", error);
        const message = this.uiLanguage === "en"
          ? this.t("excel.downloadFailed")
          : (error?.response?.data?.error || this.t("excel.downloadFailed"));
        this.toast.error(message);
      } finally {
        this.exportandoTodos = false;
      }
    },

    // ----------------------------
    // Multicheck/select coercers (NUEVO/MEJORADO)
    // ----------------------------
    _normOpt(s) {
      return normKey(s); // ✅ ahora ignora acentos/ortografía básica
    },


    _pickOptionText(o) {
      if (o == null) return "";
      if (typeof o === "string" || typeof o === "number") return String(o).trim();
      if (typeof o === "object") return String(o.value ?? o.label ?? o.nombre ?? "").trim();
      return "";
    },

    _normOptions(opciones) {
      const arr = Array.isArray(opciones) ? opciones : [];
      return arr.map(this._pickOptionText).filter(Boolean);
    },

    _slugify(s) {
      return String(s || "")
        .trim()
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-z0-9]+/g, "_")
        .replace(/^_+|_+$/g, "")
        .slice(0, 40);
    },

    _truthy(v) {
      const s = String(v ?? "").trim().toLowerCase();
      if (!s) return false;
      return ["si", "sí", "yes", "y", "1", "true", "x", "ok", "checked"].includes(s);
    },

    _coerceSelectByOptions(raw, opciones) {
      const val = String(raw ?? "").trim();
      if (!val) return "";

      const opts = this._normOptions(opciones);
      const map = new Map(opts.map((o) => [this._normOpt(o), o]));
      return map.get(this._normOpt(val)) || "";
    },

    _coerceMultiByOptions(raw, opciones) {
      const text = String(raw ?? "").trim();
      if (!text) return "";

      const opts = this._normOptions(opciones);
      const map = new Map(opts.map((o) => [this._normOpt(o), o]));

      // acepta coma, punto y coma, pipes, saltos de línea
      const parts = text
        .replace(/\n/g, ",")
        .replace(/;/g, ",")
        .replace(/\|/g, ",")
        .split(",")
        .map((x) => x.trim())
        .filter(Boolean);

      const out = [];
      const seen = new Set();

      for (const p of parts) {
        const canon = map.get(this._normOpt(p));
        if (!canon) continue;
        if (seen.has(canon)) continue;
        seen.add(canon);
        out.push(canon);
      }

      return out.join(",");
    },

    _collectMulticheckFromSplitColumns(f, headerIndex, row) {
      const label = f.label;
      const opts = this._normOptions(f.opciones);
      if (!opts.length) return "";

      const baseNames = getEventFieldHeaderAliases(f);
      const seps = [" — ", " - ", " – ", "—", "-", "–"];

      const selected = [];
      for (const opt of opts) {
        let col = -1;

        // 1) Busca por encabezado “Nombre — Opción”
        for (const baseName of baseNames) {
          for (const sep of seps) {
            const hdr = `${baseName}${sep}${opt}`.trim();
            col = this._resolveColIndex(hdr, headerIndex);
            if (col !== -1) break;
          }
          if (col !== -1) break;
        }

        // 2) Busca por key tipo label__slug (por si el Excel trae keys)
        if (col === -1) {
          const key = `${label}__${this._slugify(opt)}`;
          col = this._resolveColIndex(key, headerIndex);
        }

        if (col !== -1) {
          const raw = this._getCell(row, col);
          if (this._truthy(raw)) selected.push(opt);
        }
      }

      return selected.join(",");
    },

    // ----------------------------
    // Reactividad de grupo modificado
    // ----------------------------
    markGroupAsModified(group_id) {
      this.groupsModified[group_id] = true;
    },

    updateMembers({ groupId, category, members }) {
      const groupIndex = this.groups.findIndex((group) => String(group.group_id) === String(groupId));
      if (groupIndex === -1 || !category) return;

      const currentGroup = this.groups[groupIndex];
      const nextGroup = {
        ...currentGroup,
        staff_members: {
          ...(currentGroup.staff_members || {}),
          [category]: Array.isArray(members) ? members : [],
        },
      };

      this.groups.splice(groupIndex, 1, nextGroup);
      this.markGroupAsModified(groupId);
    },

    async confirmResetCategoryUsers({ groupId, category, title, count }) {
      if (!this.$canView('superadministrador')) {
        this.toast.error(this.t('members.onlySuperAdminReset'));
        return;
      }

      if (!groupId || !category) {
        this.toast.error(this.t('members.invalidResetTarget'));
        return;
      }

      const group = this.groups.find((g) => String(g.group_id) === String(groupId));
      const groupName = group?.group_name || groupId;
      const categoryName = title || this.getExportCategoryTitle(category);
      const total = Number(count || this.categoryRegisteredCount(group, category) || 0);

      const confirmed = window.confirm(this.t('members.resetConfirm', {
        total,
        category: categoryName,
        group: groupName,
      }));

      if (!confirmed) return;

      try {
        const token = this.$store.state.user.token;
        const response = await axios.post(`/api/staff/reset-category/${groupId}`, {
          Authorization: `${token}`,
          evento_token: this.eventoToken,
          category,
        });

        if (!response?.data?.success) {
          throw new Error(response?.data?.message || this.t('members.resetListFailed'));
        }

        this.toast.success(response.data.message || this.t('members.resetListSuccess'));
        await this.resetGroupModification(groupId);
        this.fetchGroups(this.pager.currentPage || 1);
      } catch (error) {
        console.error('Error al reiniciar lista:', error);
        const message = error?.response?.data?.message || error?.message || this.t('members.resetListError');
        this.toast.error(message);
      }
    },

    async resetGroupModification(group_id) {
      if (Object.prototype.hasOwnProperty.call(this.groupsModified, group_id)) {
        delete this.groupsModified[group_id];
        delete this.groupDraftsById[group_id];
        this.groupsModified = { ...this.groupsModified };
      }
    },

    canApprove(user) {
      return user && !user.isModified && user.isSaved;
    },

    // ----------------------------
    // UI / Accordion / File input
    // ----------------------------
    triggerFileInput(groupId, category) {
      this.selectedGroupId = groupId;
      this.selectedCategory = category;

      const fileInput = document.getElementById("file-input-" + category + "-" + groupId);
      this.excelLoading = { group_id: groupId, category: category };
      fileInput.click();
    },

    toggleAccordion(groupId, category) {
      if (this.expandedGroup === groupId && this.expandedCategory === category) {
        this.expandedGroup = null;
        this.expandedCategory = null;
      } else {
        this.expandedGroup = groupId;
        this.expandedCategory = category;
      }
    },

    isAccordionOpen(groupId, category) {
      return this.expandedGroup === groupId && this.expandedCategory === category;
    },

    cacheCurrentModifiedGroups() {
      (this.groups || []).forEach((group) => {
        if (group?.group_id && this.groupsModified[group.group_id]) {
          this.groupDraftsById[group.group_id] = JSON.parse(JSON.stringify(group));
        }
      });
    },

    mergeDraftedGroups(groups) {
      return (groups || []).map((group) => {
        if (group?.group_id && this.groupDraftsById[group.group_id]) {
          return this.groupDraftsById[group.group_id];
        }
        return group;
      });
    },

    handleGroupSearchInput() {
      clearTimeout(this.groupSearchTimer);
      this.groupSearchTimer = setTimeout(() => {
        this.fetchGroups(1);
      }, 300);
    },

    clearGroupSearch() {
      this.groupSearch = "";
      clearTimeout(this.groupSearchTimer);
      this.fetchGroups(1);
    },

    async fetchDocumentosDescargables() {
      try {
        const response = await axios.get('/api/eventos/' + this.eventoToken + '/documentos');
        const data = response?.data || {};
        const docs = Array.isArray(data.documentos) ? data.documentos : Array.isArray(data.data) ? data.data : [];

        this.documentosDescargables = docs
          .filter((doc) => doc && doc.download_url && String(doc.activo ?? "1") !== "0")
          .sort((a, b) => Number(a.orden || 0) - Number(b.orden || 0));
      } catch (error) {
        console.error("Error fetching event downloadable documents:", error);
        this.documentosDescargables = [];
      }
    },

    async fetchDisponibilidadReservas() {
      try {
        const response = await fetch(`/api/evento/recintos-por-token/${this.eventoToken}`);
        const data = await response.json();
        this.tieneRecintosReservas = Array.isArray(data?.recintos) && data.recintos.length > 0;
      } catch (error) {
        console.error("Error fetching reservation availability:", error);
        this.tieneRecintosReservas = false;
      }
    },

    // ----------------------------
    // Fetch groups
    // ----------------------------
    fetchGroups(page = 1) {
      const token = this.$store.state.user.token;
      let url = `/api/usuarios/${this.eventoToken}`;
      if (this.grupoToken) url += `/${this.grupoToken}`;

      this.cacheCurrentModifiedGroups();
      this.loading = true;

      axios
        .post(url, {
          Authorization: `${token}`,
          page: page,
          search: String(this.groupSearch || "").trim(),
        })
        .then((response) => {
          this.infoEvento = response.data.evento;

          if (this.infoEvento.permitir_duplicados == "0") {
            this.validarMandatorio = true;
          }

          // ✅ IMPORTANTÍSIMO: aquí dejamos la versión completa con tipo_ui y opciones
          this.camposObligatorios = JSON.parse(response.data.evento.campos_obligatorios).map((campo) => {
            const label = campo.label;

            // fallback para legacy
            let tipo = campo.tipo_campo || "texto";
            if (label === "correo_electronico" && tipo === "texto") tipo = "email";
            if (label === "numero_de_documento" && tipo === "texto") tipo = "sanitizado";

            const isPais = label === "pais";
            return {
              id_campo: campo.id_campo ?? null,
              label,
              nombre_del_campo: campo.nombre_del_campo ?? "",
              nombre_del_campo_en: campo.nombre_del_campo_en ?? "",
              tipo_campo: tipo,

              // ✅ país siempre será select (aunque en admin sea "campo base")
              tipo_ui: isPais ? "select" : (campo.tipo_ui ?? "input"),

              // ✅ lista de países para el select de país
              opciones: isPais ? PAISES : (Array.isArray(campo.opciones) ? campo.opciones : []),

              activo: !!campo.activo,
              requerido: !!campo.requerido,
              mandatorio: !!campo.mandatorio,
              custom: !!campo.custom,
              orden: Number(campo.orden) > 0 ? Number(campo.orden) : null,
            };
          });

          const normalizedGroups = (response.data.groups || []).map((group) => {
            group.staff = Number(group.staff);
            group.conferencistas = Number(group.conferencistas);
            group.asistentes = Number(group.asistentes);
            group.mostrar_staff = String(group.mostrar_staff ?? (group.staff > 0 ? '1' : '0'));
            group.mostrar_asistentes = String(group.mostrar_asistentes ?? (group.asistentes > 0 ? '1' : '0'));
            group.mostrar_conferencistas = String(group.mostrar_conferencistas ?? (group.conferencistas > 0 ? '1' : '0'));

            ["staff", "conferencistas", "asistentes"].forEach((category) => {
              group.staff_members[category] = (group.staff_members[category] || []).map((member) => ({
                ...member,
                isModified: false,
                isSaved: this.checkIfMemberComplete(member),
              }));
            });

            return group;
          });

          this.groups = this.mergeDraftedGroups(normalizedGroups);

          const fechaParts = response.data.fecha.split(" ")[0].split("-");
          const fechaDeCorte = new Date(fechaParts[0], fechaParts[1] - 1, fechaParts[2]);

          const fechaActual = new Date();
          fechaActual.setHours(0, 0, 0, 0);
          this.fechaCorte = fechaActual >= fechaDeCorte;

          this.applyEventLabels(response.data.evento);

          if (this.fechaCorte) this.toast.info(this.t('page.cutoffReached'));

          this.pager = response.data.pager;
          this.loading = false;

          this.groups = fillExistingData(this.groups, this.camposObligatorios, { unlimited: this.sinLimitesCargaUsuarios });
          this.groups = this.mergeDraftedGroups(this.groups);
        })
        .catch((error) => {
          console.error("Error fetching groups:", error);
          this.loading = false;
          if (error.response && error.response.status === 403) {
            this.$router.push({ name: "Forbidden" });
          }
        });
    },

    checkIfMemberComplete(member) {
      const requiredFields = ["nombres", "apellidos", "correo_electronico"];
      return requiredFields.every((field) => member[field] && String(member[field]).trim() !== "");
    },

    handleGroupUpdated(updatedGroup) {
      const updatedIndex = this.groups.findIndex((group) => group.group_id === updatedGroup.group_id);
      if (updatedIndex !== -1) {
        const mergedGroup = { ...this.groups[updatedIndex], ...updatedGroup };
        const normalizedGroup = fillExistingData([mergedGroup], this.camposObligatorios, { unlimited: this.sinLimitesCargaUsuarios })[0];

        ['staff', 'conferencistas', 'asistentes'].forEach((category) => {
          normalizedGroup.staff_members[category] = (normalizedGroup.staff_members?.[category] || []).map((member) => ({
            ...member,
            isModified: false,
            isSaved: this.checkIfMemberComplete(member),
          }));
        });

        this.groups.splice(updatedIndex, 1, normalizedGroup);
        delete this.groupDraftsById[updatedGroup.group_id];
        this.toast.success(this.t('groups.updated'));
      }
    },

    categoryVisible(group, category) {
      const members = Array.isArray(group?.staff_members?.[category])
        ? group.staff_members[category]
        : [];

      if (!this.sinLimitesCargaUsuarios) {
        return Number(group?.[category] || 0) > 0 || this.categoryRegisteredCount(group, category) > 0;
      }

      if (category === 'staff') return String(group?.mostrar_staff || '0') === '1' || members.length > 0;
      if (category === 'conferencistas') return String(group?.mostrar_conferencistas || '0') === '1' || members.length > 0;
      if (category === 'asistentes') return String(group?.mostrar_asistentes || '0') === '1' || members.length > 0;
      return false;
    },

    categoryRegisteredCount(group, category) {
      const members = Array.isArray(group?.staff_members?.[category])
        ? group.staff_members[category]
        : [];
      const exportFields = this.camposExportacionOrdenados();
      return members.filter((member) => this.isMeaningfulExportMember(member, exportFields)).length;
    },

    categoryDisplayCount(group, category) {
      const registered = this.categoryRegisteredCount(group, category);

      if (!this.sinLimitesCargaUsuarios) {
        const capacity = this.getCategoryCapacity(group, category);
        return capacity > 0 ? `${registered}/${capacity}` : String(registered);
      }

      return String(registered);
    },

    cleanPhoneNumber(value) {
      return String(value || "").replace(/[^0-9()\-[\]+/]/g, "");
    },

    updatePhoneNumber(member, newValue) {
      member.telefono = this.cleanPhoneNumber(newValue);
    },

    getMember(group, category, index, field) {
      if (!group.staff_members[category][index]) {
        this.$set(group.staff_members[category], index, { nombres: "", apellidos: "" });
      }
      return group.staff_members[category][index][field];
    },

    showModal(group, category, index) {
      this.currentGroup = group;
      this.currentCategory = category;
      this.currentIndex = index;
      this.isModalVisible = true;
    },

    clearMember() {
      if (this.currentGroup && this.currentCategory !== null && this.currentIndex !== null) {
        const member = this.currentGroup.staff_members[this.currentCategory][this.currentIndex];

        if (member && member.staff_id) {
          axios
            .post(`/api/delete-staff/${member.staff_id}`, {
              Authorization: this.$store.state.user.token,
            })
            .then((response) => {
              if (response.data.success) {
                if (this.sinLimitesCargaUsuarios || response.data.deleted) {
                  this.currentGroup.staff_members[this.currentCategory].splice(this.currentIndex, 1);
                  this.toast.success(this.t('members.deleted'));
                } else {
                  const newMember = {
                    nombres: "",
                    apellidos: "",
                    numero_de_documento: "",
                    correo_electronico: "",
                    tipo_de_documento: "",
                    telefono: "",
                    ciudad: "",
                    pais: "",
                    departamento: "",
                    categoria: "",
                    estado: "",
                    empresa: "",
                    profesion: "",
                    especialidad: "",
                    direccion: "",
                    indicativo_de_telefono: "",
                    staff_id: member.staff_id,
                  };

                  this.currentGroup.staff_members[this.currentCategory].splice(this.currentIndex, 1, newMember);
                  this.toast.success(this.t('members.reset'));
                }
              } else {
                this.toast.error(this.t('members.resetFailed'));
              }
            })
            .catch((error) => {
              console.error("Error al reiniciar el miembro:", error);
              this.toast.error(this.t('members.requestFailed'));
            });
        }
      }
      this.closeModal();
    },

    closeModal() {
      this.isModalVisible = false;
    },

    performSaveAllMembers(group) {
      const toast = useToast();
      saveAllMembers(group, toast, { authToken: this.$store.state.user.token });
    },

    async performSaveStaffMembers(group, audit = null) {
      const toast = useToast();
      const success = await saveStaffMembers(group, toast, this.camposObligatorios, this.validarMandatorio, this.eventoToken, {
        authToken: this.$store.state.user.token,
        audit,
      });
      if (success) await this.resetGroupModification(group.group_id);
      return success;
    },

    async performSaveConferencistas(group, audit = null) {
      const toast = useToast();
      const success = await saveConferencistas(group, toast, this.camposObligatorios, this.validarMandatorio, this.eventoToken, {
        authToken: this.$store.state.user.token,
        audit,
      });
      if (success) await this.resetGroupModification(group.group_id);
      return success;
    },

    async performSaveAsistentes(group, audit = null) {
      const toast = useToast();
      const success = await saveAsistentes(group, toast, this.camposObligatorios, this.validarMandatorio, this.eventoToken, {
        authToken: this.$store.state.user.token,
        audit,
      });
      if (success) await this.resetGroupModification(group.group_id);
      return success;
    },

    checkPropAutorizado(member) {
      if (member && "autorizado" in member) return member.autorizado === "1";
      return false;
    },

    markUserAsModified(groupId, userId) {
      const groupIndex = this.groups.findIndex((g) => g.group_id === groupId);
      const userIndex = this.groups[groupIndex].users.findIndex((u) => u.id === userId);
      if (userIndex !== -1) {
        this.groups[groupIndex].users[userIndex].isModified = true;
        this.groups[groupIndex].users[userIndex].isSaved = false;
      }
    },

    saveUserData(groupId, userId) {
      const groupIndex = this.groups.findIndex((g) => g.group_id === groupId);
      const userIndex = this.groups[groupIndex].users.findIndex((u) => u.id === userId);
      if (userIndex !== -1) {
        axios
          .post("/api/save-user-data", this.groups[groupIndex].users[userIndex])
          .then(() => {
            this.groups[groupIndex].users[userIndex].isModified = false;
            this.groups[groupIndex].users[userIndex].isSaved = true;
          })
          .catch((error) => {
            console.error("Error saving user data:", error);
          });
      }
    },

    handleFileChange(event, groupId, category) {
      const file = event.target.files[0];
      if (!file) return;
      this.selectedFile = file;
      this.selectedGroupId = groupId;
      this.selectedCategory = category;
      this.showConfirmationModal = true;
    },

    // ----------------------------
    // Helpers: headers / normalización
    // ----------------------------
    _humanizeLabel(s) {
      return String(s || "")
        .replace(/_/g, " ")
        .replace(/\s+/g, " ")
        .trim()
        .replace(/^./, (m) => m.toUpperCase());
    },

    _normHeader(s) {
      return String(s || "")
        .trim()
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-z0-9]+/g, " ")
        .trim();
    },

    _buildHeaderIndex(headerRow) {
      const idx = {};
      (headerRow || []).forEach((h, i) => {
        const key = this._normHeader(h);
        if (key) idx[key] = i;
      });
      return idx;
    },

    _resolveColIndex(label, headerIndex, field = null) {
      const fieldConfig = field || { label };
      const candidates = getEventFieldHeaderAliases(fieldConfig)
        .concat([label])
        .map(this._normHeader.bind(this));

      for (const c of candidates) {
        if (c && Object.prototype.hasOwnProperty.call(headerIndex, c)) {
          return headerIndex[c];
        }
      }
      return -1;
    },

    _getCell(row, idx) {
      if (!Array.isArray(row) || idx < 0) return "";
      const v = row[idx];
      if (typeof v === "number") return String(Math.trunc(v));
      return String(v ?? "");
    },

    _coerceTipoDocumento(val) {
      const raw = String(val ?? "").trim();
      if (!raw) return "";

      const up = raw.toUpperCase();
      if (up.startsWith("CC") || up.includes("CEDULA") || up.includes("CIUDADANIA")) return "CC";
      if (up.startsWith("CE") || up.includes("EXTRANJERIA")) return "CE";
      if (up.includes("PASAPORTE") || up.includes("PASSPORT")) return "Pasaporte";
      if (raw === "CC" || raw === "CE" || raw === "Pasaporte") return raw;
      return "";
    },

    // ----------------------------
    // Sanitización
    // ----------------------------
    sanitizeMemberData(member) {
      const out = { ...member };

      out.correo_electronico = String(out.correo_electronico || "").replace(/\s+/g, "");
      out.numero_de_documento = String(out.numero_de_documento || "")
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, "");

      out.tipo_de_documento = this._coerceTipoDocumento(out.tipo_de_documento);

      if (out.telefono !== undefined) {
        out.telefono = String(out.telefono || "").replace(/[^0-9()+\- ]/g, "");
      }

      return out;
    },

    // ----------------------------
    // Upload Excel
    // ----------------------------
    selectedCategoryLabel() {
      if (this.selectedCategory === "conferencistas") return this.displayLabelExpositor;
      if (this.selectedCategory === "asistentes") return this.displayLabelAsistentes;
      if (this.selectedCategory === "staff") return this.displayLabelStaff;
      return this.t("excel.users");
    },

    _isEffectivelyEmptyMember(member, activeFields = []) {
      const labels = (activeFields || [])
        .filter((f) => f && f.label && !NON_MEMBER_DATA_FIELDS.has(f.label))
        .map((f) => f.label);

      if (!labels.length) {
        return Object.entries(member || {}).every(([label, value]) => (
          NON_MEMBER_DATA_FIELDS.has(label) || String(value ?? "").trim() === ""
        ));
      }

      return labels.every((label) => String(member?.[label] ?? "").trim() === "");
    },

    _sanitizeValueForMatch(field, value) {
      const raw = String(value ?? "").trim();
      if (!raw) return "";

      const label = field?.label || "";
      const tipo = String(field?.tipo_campo || "texto").toLowerCase();
      const ui = String(field?.tipo_ui || "input").toLowerCase();

      if (ui === "multicheck") {
        return raw
          .split(",")
          .map((item) => this._normHeader(item))
          .filter(Boolean)
          .sort()
          .join("|");
      }

      if (label === "tipo_de_documento") {
        return this._normHeader(this._coerceTipoDocumento(raw));
      }

      if (label === "correo_electronico" || tipo === "email") {
        return raw.replace(/\s+/g, "").toLowerCase();
      }

      if (label === "numero_de_documento" || tipo === "sanitizado") {
        return raw.toUpperCase().replace(/[^A-Z0-9]/g, "");
      }

      if (tipo === "numero") {
        return raw.replace(/[^0-9]/g, "");
      }

      return this._normHeader(raw);
    },

    _buildMasterSignature(member, masterFields = []) {
      if (!Array.isArray(masterFields) || !masterFields.length) return "";

      const parts = [];
      for (const field of masterFields) {
        const value = this._sanitizeValueForMatch(field, member?.[field.label]);
        if (!value) return "";
        parts.push(`${field.label}:${value}`);
      }

      return parts.join("||");
    },

    _findBlankMemberIndex(members, activeFields = [], usedIndexes = new Set()) {
      return members.findIndex((member, index) => {
        if (usedIndexes.has(index)) return false;
        return this._isEffectivelyEmptyMember(member, activeFields);
      });
    },

    _formatExcelRows(rows, activeFields, headerIndex, existingMembers, staffIdCol) {
      return rows.map((row) => {
        const obj = {};

        for (const f of activeFields) {
          const label = f.label;
          const ui = String(f.tipo_ui || "input").toLowerCase();

          const col = this._resolveColIndex(label, headerIndex, f);

          if (ui === "multicheck") {
            if (col !== -1) {
              const raw = this._getCell(row, col);
              obj[label] = this._coerceMultiByOptions(raw, f.opciones);
            } else {
              const csv = this._collectMulticheckFromSplitColumns(f, headerIndex, row);
              obj[label] = this._coerceMultiByOptions(csv, f.opciones);
            }
            continue;
          }

          if (col === -1) continue;

          const raw = this._getCell(row, col);
          if (label === "tipo_de_documento") {
            obj[label] = this._coerceTipoDocumento(raw);
          } else if (ui === "select") {
            obj[label] = this._coerceSelectByOptions(raw, f.opciones);
          } else {
            obj[label] = raw;
          }
        }

        const fromFile = staffIdCol !== -1 ? this._getCell(row, staffIdCol) : "";
        obj.staff_id = fromFile ? fromFile : null;

        return this.sanitizeMemberData(obj);
      });
    },

    _buildOverwriteMembers(existingMembers, formattedData, activeFields = []) {
      return existingMembers.map((member, index) => {
        const incoming = index < formattedData.length ? formattedData[index] : null;
        if (incoming && !this._isEffectivelyEmptyMember(incoming, activeFields)) {
          return {
            ...member,
            ...incoming,
            staff_id: incoming.staff_id || member.staff_id || null,
            isModified: true,
            isSaved: false,
          };
        }
        return member;
      });
    },

    _buildMergeMembers(existingMembers, formattedData, activeFields, masterFields, categoryLabel) {
      const mergedMembers = existingMembers.map((member) => ({ ...member }));
      const signatureIndexMap = new Map();
      const usedIndexes = new Set();
      const incomingRows = (formattedData || []).filter((member) => !this._isEffectivelyEmptyMember(member, activeFields));

      mergedMembers.forEach((member, index) => {
        if (this._isEffectivelyEmptyMember(member, activeFields)) return;

        const signature = this._buildMasterSignature(member, masterFields);
        if (!signature) return;

        if (!signatureIndexMap.has(signature)) {
          signatureIndexMap.set(signature, []);
        }
        signatureIndexMap.get(signature).push(index);
      });

      const stats = { updated: 0, added: 0, skipped: 0 };

      incomingRows.forEach((incoming) => {
        let targetIndex = -1;
        const incomingStaffId = String(incoming.staff_id || "").trim();

        if (incomingStaffId) {
          targetIndex = mergedMembers.findIndex((member, index) => {
            if (usedIndexes.has(index)) return false;
            return String(member?.staff_id || "").trim() === incomingStaffId;
          });
        }

        if (targetIndex === -1) {
          const signature = this._buildMasterSignature(incoming, masterFields);
          const candidates = signature ? signatureIndexMap.get(signature) || [] : [];
          targetIndex = candidates.find((index) => !usedIndexes.has(index));
          if (typeof targetIndex !== "number") targetIndex = -1;
        }

        if (targetIndex !== -1) {
          const current = mergedMembers[targetIndex] || {};
          mergedMembers[targetIndex] = {
            ...current,
            ...incoming,
            staff_id: current.staff_id || incoming.staff_id || null,
            isModified: true,
            isSaved: false,
          };
          usedIndexes.add(targetIndex);
          stats.updated += 1;
          return;
        }

        const blankIndex = this._findBlankMemberIndex(mergedMembers, activeFields, usedIndexes);
        if (blankIndex !== -1) {
          const current = mergedMembers[blankIndex] || {};
          mergedMembers[blankIndex] = {
            ...current,
            ...incoming,
            escarapela: current.escarapela || categoryLabel,
            autorizado: current.autorizado ?? "0",
            isModified: true,
            isSaved: false,
          };
          usedIndexes.add(blankIndex);
          stats.added += 1;
          return;
        }

        if (this.sinLimitesCargaUsuarios) {
          mergedMembers.push({
            ...incoming,
            escarapela: categoryLabel,
            autorizado: incoming.autorizado ?? "0",
            isModified: true,
            isSaved: false,
          });
          stats.added += 1;
          return;
        }

        stats.skipped += 1;
      });

      return { members: mergedMembers, stats };
    },

    hydrateSavedMembers(members, activeFields = []) {
      return (members || []).map((member) => {
        if (!member || typeof member !== "object") return member;

        const hasData = !this._isEffectivelyEmptyMember(member, activeFields);
        if (!hasData || !member.staff_id) return member;

        return {
          ...member,
          isModified: false,
          isSaved: this.checkIfMemberComplete(member),
        };
      });
    },

    async startUploadAudit(file, groupId, category, strategy) {
      const formData = new FormData();
      formData.append("archivo", file);
      formData.append("Authorization", this.$store.state.user.token || "");
      formData.append("evento_token", this.eventoToken);
      formData.append("grupo_token", groupId);
      formData.append("categoria", category);
      formData.append("modo_importacion", strategy);
      const response = await axios.post("/api/auditoria/importaciones/iniciar", formData);
      return Number(response?.data?.audit_id || 0);
    },

    async finalizeUploadAudit(auditId, message, details = {}) {
      if (!auditId) return;
      try {
        await axios.post(`/api/auditoria/importaciones/${auditId}/finalizar`, {
          Authorization: this.$store.state.user.token,
          estado: details.estado || "fallido",
          mensaje: message,
          registros_archivo: Number(details.rows || 0),
          registros_omitidos: Number(details.skipped || 0),
          errores: Array.isArray(details.errors) ? details.errors : [],
        });
      } catch (error) {
        // Un 409 significa normalmente que el backend ya cerró la auditoría.
        if (error?.response?.status !== 409) {
          console.error("No se pudo cerrar la auditoría de la carga:", error);
        }
      }
    },

    async confirmUpload(strategy = "overwrite") {
      this.showConfirmationModal = false;

      if (!this.selectedFile) {
        this.toast.error(this.t("excel.fileNotFound"));
        this.excelLoading = { group_id: null, category: "" };
        return;
      }

      const file = this.selectedFile;
      const groupId = this.selectedGroupId;
      const category = this.selectedCategory;
      let auditId = 0;

      try {
        auditId = await this.startUploadAudit(file, groupId, category, strategy);
      } catch (error) {
        const message = error?.response?.data?.message || this.t("excel.processingError");
        this.toast.error(message);
        this.excelLoading = { group_id: null, category: "" };
        return;
      }

      const reader = new FileReader();
      reader.onload = async (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });

          const sheetName = workbook.SheetNames.includes("Plantilla")
            ? "Plantilla"
            : (workbook.SheetNames.includes("Template") ? "Template" : workbook.SheetNames[0]);

          const aoa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], {
            header: 1,
            defval: "",
            blankrows: false,
          });

          await this.prepareDataForUpload(aoa, groupId, category, strategy, { id: auditId });
        } catch (error) {
          console.error("Error al leer el archivo:", error);
          await this.finalizeUploadAudit(auditId, "El archivo no pudo interpretarse como una plantilla válida.");
          this.toast.error(this.t("excel.processingError"));
          this.excelLoading = { group_id: null, category: "" };
        }
      };

      reader.onerror = async () => {
        await this.finalizeUploadAudit(auditId, "El navegador no pudo leer el archivo seleccionado.");
        this.toast.error(this.t("excel.processingError"));
        this.excelLoading = { group_id: null, category: "" };
      };

      reader.readAsArrayBuffer(file);
    },

    // ✅ AQUI VAN TODOS LOS AJUSTES (select + multicheck)
    async prepareDataForUpload(data, groupId, category, strategy = "overwrite", auditContext = null) {
      const group = this.groups.find((g) => g.group_id === groupId);
      if (!group) {
        console.error("Grupo no encontrado");
        await this.finalizeUploadAudit(auditContext?.id, "El grupo de destino ya no está disponible.");
        this.excelLoading = { group_id: null, category: "" };
        return;
      }

      const capacity = Number(group[category] || 0);
      if (!this.sinLimitesCargaUsuarios && !capacity) {
        this.toast.error(this.t("excel.invalidCapacity"));
        await this.finalizeUploadAudit(auditContext?.id, "La categoría no tiene capacidad configurada.");
        this.excelLoading = { group_id: null, category: "" };
        return;
      }

      const headerRow = Array.isArray(data?.[0]) ? data[0] : [];
      const headerIndex = this._buildHeaderIndex(headerRow);
      const activeFields = (this.camposObligatorios || []).filter((f) => f && f.activo && f.label);
      const masterFields = activeFields.filter((field) => field.mandatorio);
      const rows = this.sinLimitesCargaUsuarios ? (data || []).slice(1) : (data || []).slice(1, capacity + 1);
      const existingMembers = (group.staff_members[category] || []).map((member) => ({ ...member }));
      const staffIdCol = this._resolveColIndex("staff_id", headerIndex);
      const formattedData = this._formatExcelRows(rows, activeFields, headerIndex, existingMembers, staffIdCol);

      let updatedMembers = [];
      let mergeStats = null;

      if (strategy === "merge") {
        if (!masterFields.length) {
          this.toast.error(this.t("excel.noMasterFields"));
          await this.finalizeUploadAudit(auditContext?.id, "El evento no tiene campos maestros para completar registros.");
          this.excelLoading = { group_id: null, category: "" };
          return;
        }

        const mergeResult = this._buildMergeMembers(
          existingMembers,
          formattedData,
          activeFields,
          masterFields,
          category === "staff" ? "Staff" : category === "conferencistas" ? "Conferencista" : "Asistente"
        );

        updatedMembers = mergeResult.members;
        mergeStats = mergeResult.stats;
      } else {
        updatedMembers = this._buildOverwriteMembers(existingMembers, this.sinLimitesCargaUsuarios ? formattedData : formattedData.slice(0, capacity), activeFields);
      }

      if (strategy === "merge" && mergeStats && mergeStats.updated === 0 && mergeStats.added === 0) {
        const message = mergeStats.skipped > 0
          ? this.t("excel.noSpaceForRows", { count: mergeStats.skipped })
          : this.t("excel.noDataRows");
        this.toast.warning(message);
        await this.finalizeUploadAudit(auditContext?.id, message, {
          rows: formattedData.length,
          skipped: mergeStats.skipped,
        });

        const inp = document.getElementById("file-input-" + category + "-" + groupId);
        if (inp) inp.value = null;

        this.selectedFile = null;
        this.selectedGroupId = null;
        this.selectedCategory = "";
        this.excelLoading = { group_id: null, category: "" };
        return;
      }

      let success = false;
      const auditRows = formattedData.filter((member) => !this._isEffectivelyEmptyMember(member, activeFields)).length;
      const audit = {
        id: auditContext?.id,
        mode: strategy,
        rows: auditRows,
        stats: mergeStats || {},
      };

      try {
        if (category === "staff") {
          success = await this.performSaveStaffMembers({
            group_id: groupId,
            staff_members: { staff: updatedMembers },
          }, audit);
        } else if (category === "conferencistas") {
          success = await this.performSaveConferencistas({
            group_id: groupId,
            staff_members: { conferencistas: updatedMembers },
          }, audit);
        } else if (category === "asistentes") {
          success = await this.performSaveAsistentes({
            group_id: groupId,
            staff_members: { asistentes: updatedMembers },
          }, audit);
        }

        if (success) {
          updatedMembers = this.hydrateSavedMembers(updatedMembers, activeFields);
        }

        this.groups = this.groups.map((g) =>
          g.group_id === groupId
            ? { ...g, staff_members: { ...g.staff_members, [category]: updatedMembers } }
            : g
        );

        if (success) {
          if (strategy === "merge" && mergeStats) {
            const baseMessage = this.t("excel.mergeCompleted", {
              updated: mergeStats.updated,
              added: mergeStats.added,
            });
            if (mergeStats.skipped > 0) {
              this.toast.warning(`${baseMessage} ${this.t("excel.rowsSkipped", { count: mergeStats.skipped })}`);
            } else {
              this.toast.success(baseMessage);
            }
          } else {
            this.toast.success(this.t("excel.dataLoaded"));
          }
          await this.resetGroupModification(group.group_id);
        } else {
          this.toast.info(this.t("excel.reviewBeforeSave"));
          await this.finalizeUploadAudit(auditContext?.id, "La carga no superó todas las validaciones.", {
            rows: auditRows,
            skipped: mergeStats?.skipped || 0,
            errors: getLastValidationErrors(),
          });
        }

        const inp = document.getElementById("file-input-" + category + "-" + groupId);
        if (inp) inp.value = null;

        this.selectedFile = null;
        this.selectedGroupId = null;
        this.selectedCategory = "";
        this.excelLoading = { group_id: null, category: "" };
      } catch (error) {
        console.error("Error al guardar datos:", error);
        await this.finalizeUploadAudit(auditContext?.id, "Ocurrió un error inesperado al procesar la carga.", {
          rows: auditRows,
          skipped: mergeStats?.skipped || 0,
        });
        this.toast.error(this.t("excel.processingError"));
        this.excelLoading = { group_id: null, category: "" };
      }
    },

    cancelUpload() {
      this.showConfirmationModal = false;
      this.selectedFile = null;
      this.selectedGroupId = null;
      this.selectedCategory = "";
      this.excelLoading = { group_id: null, category: "" };
    },

    addUser(groupId) {
      this.$router.push(`/dashboard/usuarios/agregar-usuario/${groupId}`);
    },

    async approveUser(staffId, category) {
      try {
        const response = await axios.post("/api/aprovation/staffs/check", {
          staff_member: staffId,
          Authorization: this.$store.state.user.token,
        });
        if (response.data && response.data.success) {
          this.toast.success(this.t('members.approved'));
          this.updateStaffMember(staffId, { autorizado: "1" }, category);
        }
      } catch (error) {
        console.error("Error al aprobar el staff:", error);
        this.toast.error(this.t('members.approveError'));
      }
    },

    updateStaffMember(staffId, updates, category) {
      const groupIndex = this.groups.findIndex((group) =>
        group.staff_members[category].some((member) => member.staff_id === staffId)
      );
      if (groupIndex !== -1) {
        const memberIndex = this.groups[groupIndex].staff_members[category].findIndex(
          (member) => member.staff_id === staffId
        );
        if (memberIndex !== -1) {
          this.groups[groupIndex].staff_members[category][memberIndex] = {
            ...this.groups[groupIndex].staff_members[category][memberIndex],
            ...updates,
          };
        }
      }
    },

    handleUserDeleted({ userId, groupId }) {
      this.groups = this.groups.map((group) => {
        if (group.group_id === groupId) {
          group.users = group.users.filter((user) => user.id_token !== userId);
        }
        return group;
      });
    },

    handleGroupDeleted(groupId) {
      this.groups = this.groups.filter((group) => group.group_id !== groupId);
    },
  },

  mounted() {
    setProgressModal(this.handleShowProgressModal);
    setErrorModal(this.handleShowErrorModal);
    this.fetchDisponibilidadReservas();
    this.fetchDocumentosDescargables();
    this.fetchGroups();
  },
};
</script>



<style scoped>
.lista-usuarios-page {
  position: relative;
}

.user-management-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
  padding: 0.75rem 0.9rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.75rem;
  background: #fff;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.06);
}

.user-management-toolbar.has-downloadable-documents {
  padding-left: 15rem;
}

.language-switcher {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.3rem;
  border: 1px solid #cbd5e1;
  border-radius: 0.65rem;
  background: #f8fafc;
}

.language-switcher-label {
  margin: 0 0.35rem;
  color: #475569;
  font-size: 0.78rem;
  font-weight: 700;
}

.language-option {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.4rem 0.65rem;
  border: 0;
  border-radius: 0.45rem;
  background: transparent;
  color: #475569;
  font-size: 0.78rem;
  font-weight: 800;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;
}

.language-option span {
  font-weight: 600;
}

.language-option.active {
  background: #2563eb;
  color: #fff;
  box-shadow: 0 3px 9px rgba(37, 99, 235, 0.25);
}

@media (max-width: 700px) {
  .user-management-toolbar {
    align-items: stretch;
    flex-direction: column;
  }

  .user-management-toolbar.has-downloadable-documents {
    padding-left: 0.9rem;
  }

  .language-switcher {
    justify-content: center;
  }
}

.documentos-descargables-panel {
  position: absolute;
  top: 0.85rem;
  left: 1rem;
  z-index: 20;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.55rem;
  width: 220px;
  max-width: calc(100vw - 2rem);
}

.documento-descarga-btn {
  display: block;
  width: 100%;
  padding: 0.6rem 0.8rem;
  border: 0;
  border-radius: 0.5rem;
  background: #2563eb;
  color: #fff;
  font-weight: 800;
  font-size: 0.86rem;
  line-height: 1.2;
  text-align: center;
  text-decoration: none;
  box-shadow: 0 6px 16px rgba(37, 99, 235, 0.22);
  transition: transform 0.12s ease, background 0.15s ease, box-shadow 0.15s ease;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}

.documento-descarga-btn:hover {
  background: #1d4ed8;
  transform: translateY(-1px);
  box-shadow: 0 8px 20px rgba(37, 99, 235, 0.28);
}

.documentos-modal-bg {
  position: fixed;
  inset: 0;
  z-index: 10050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: rgba(15, 23, 42, 0.55);
}

.documentos-modal-box {
  width: min(420px, 100%);
  max-height: min(560px, calc(100vh - 2rem));
  overflow: auto;
  padding: 1.1rem;
  border-radius: 0.75rem;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.32);
  backdrop-filter: blur(12px);
}

.documentos-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
}

.documentos-modal-header h3 {
  margin: 0;
  color: #1f2937;
  font-size: 1.1rem;
  font-weight: 800;
}

.documentos-modal-close {
  width: 34px;
  height: 34px;
  border: 0;
  border-radius: 0.5rem;
  background: #e5e7eb;
  color: #374151;
  font-size: 1.35rem;
  font-weight: 800;
  line-height: 1;
  cursor: pointer;
}

.documentos-modal-close:hover {
  background: #d1d5db;
}

.documentos-modal-list {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
}

.documento-descarga-btn-modal {
  white-space: normal;
}

@media (max-width: 1024px) {
  .user-management-toolbar.has-downloadable-documents {
    padding-left: 0.9rem;
  }

  .documentos-descargables-panel {
    position: static;
    width: 100%;
    margin-bottom: 1rem;
  }
  
  .documento-descarga-btn {
    white-space: normal;
  }
}
@media (min-width: 1024px) {
  .documentos-descargables-panel{
    top: 80px;
  }
}


.container {
  flex-direction: column;
}
.botones {
  width: 350px;
}
.titulo-grupo {
  display: flex;
  align-items: center;
}
.titulo-grupo div {
  margin-right: 20px;
}

.bg-green-500 { background-color: #10b981; }
.hover:bg-green-700:hover { background-color: #059669; }
.bg-blue-500 { background-color: #3b82f6; }
.hover:bg-blue-700:hover { background-color: #1e40af; }

.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.pagination button {
  padding: 10px;
  margin: 0 5px;
  background-color: #efefef;
  border: none;
  cursor: pointer;
}

.pagination button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.boton-svg {
    display: flex;
    justify-content: center;
}
.modal-trigger-button {
    background: transparent;
    border: none;
    cursor: pointer;
    /* border: 1px solid #000; */
    padding: 15px;
    border-radius: 10px;
    background: #fff;
    box-shadow: 0 0 8px rgba(0,0,0,0.7);
    position: fixed;
    z-index: 30;
    top: 7px;
    left: auto;
    right: auto;
    /* margin: auto; */
    transition: all 0.2s;
}
.modal-trigger-button:hover{
    background: #2959a6;
    box-shadow: 0 0 8px rgba(255,255,255,0.7);
    
}
.modal-trigger-button:hover svg{
    fill: #fff;    
}

.modal-trigger-button svg {
    transition: all 0.2s;
    fill: gray;
    transform: scale(2);
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
}

.modal-content {
  /* background: white; */
  padding: 20px;
  border-radius: 10px;
  backdrop-filter: blur(10px);
  background-color: rgba(255, 255, 255, 0.7);
}

.boton-front{
    display: block;
    margin-bottom: 16px;
}
button svg {
    min-width: 20px;
}
.boton-tutorial {
  /* position: absolute; */
  display: flex;  
  right: 20px;
  z-index: 3;
  position: fixed;
  z-index: 30;
  top: 14px;
  left: auto;
  
}
.boton-tutorial a {
  display: inline-block;
  padding: 5px 10px;
  background: rgb(230, 11, 11);
  color: #fff;
  border-radius: 10px;
}


/* Overlay para ambos modales */
.overlay {
  position: fixed;
  top: 0; left: 0;
  width: 100vw; height: 100vh;
  background: rgba(0,0,0,0.65);
  z-index: 1001;
}

/* Estilo base de ambos modales */
.modal-progress,
.modal-errores {
  position: fixed;
  top: 50%; left: 50%;
  transform: translate(-50%, -50%);
  min-width: 320px;
  max-width: 95vw;
  min-height: 120px;
  background: white;
  border-radius: 18px;
  box-shadow: 0 10px 32px rgba(0,0,0,0.25), 0 2px 4px rgba(0,0,0,0.18);
  z-index: 1002;
  padding: 32px 28px 20px 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: modalPop 0.18s cubic-bezier(0.68,-0.55,0.27,1.55);
}

/* Títulos */
.modal-progress h2,
.modal-errores h2 {
  margin-bottom: 18px;
  font-size: 1.3rem;
  font-weight: 700;
  color: #1e3a8a;
  text-align: center;
}

/* Lista de errores */
.modal-errores ul {
  width: 100%;
  max-height: 38vh;
  overflow-y: auto;
  text-align: left;
  padding: 0 8px;
  margin-bottom: 20px;
}
.modal-errores li {
  margin-bottom: 8px;
  color: #be123c;
  font-size: 1.02rem;
  border-left: 3px solid #be123c;
  padding-left: 8px;
  background: rgba(254,226,226,0.45);
  border-radius: 4px;
}

/* Botón cerrar */
.modal-errores button {
  margin-top: 6px;
  padding: 9px 28px;
  background: #be123c;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 1.05rem;
  cursor: pointer;
  font-weight: 600;
  box-shadow: 0 2px 7px rgba(0,0,0,0.10);
  transition: background 0.18s;
}
.modal-errores button:hover {
  background: #7f1d1d;
}

/* Animación modal */
@keyframes modalPop {
  0% { transform: translate(-50%, -45%) scale(0.98);}
  100% { transform: translate(-50%, -50%) scale(1);}
}

/* Responsive */
@media (max-width: 480px) {
  .modal-progress, .modal-errores {
    min-width: 95vw;
    padding: 18px 6vw 14px 6vw;
  }
  .modal-errores ul { max-height: 35vh; }
}



.group-search-panel {
  width: min(560px, 100%);
  margin: 18px auto 24px auto;
  padding: 14px 16px;
  border: 1px solid rgba(148, 163, 184, 0.25);
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 14px 32px rgba(15, 23, 42, 0.08);
  text-align: center;
}

.group-search-label {
  display: block;
  margin-bottom: 8px;
  color: #1f2937;
  font-weight: 700;
}

.group-search-box {
  display: flex;
  gap: 10px;
  align-items: center;
}

.group-search-input {
  width: 100%;
  border: 1px solid rgba(148, 163, 184, 0.55);
  border-radius: 999px;
  padding: 10px 16px;
  outline: none;
  color: #111827;
  background: #fff;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.group-search-input:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.16);
}

.group-search-clear {
  border: none;
  border-radius: 999px;
  padding: 10px 14px;
  background: #e5e7eb;
  color: #374151;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;
}

.group-search-clear:hover {
  background: #d1d5db;
  transform: translateY(-1px);
}

.group-search-help {
  margin: 8px 0 0 0;
  color: #6b7280;
  font-size: 0.84rem;
}

</style>
